import { css } from "@compiled/react";

import { JiraOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    JoinableSites
} from "@/components/signup/site-activation";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    JoinableSitesSubheading,
    JoinableSitesText,
    WelcomeBackText,
    WelcomeBackHeading
} from "../../../components";

export const CurrentProductJoinableUser = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );

    return (
        <JiraOverlayTemplate size="sm">
            <div css={containerCss}>
                {team26VisualUpdates ? (
                    <Headings
                        main={<WelcomeBackText />}
                        sub={<JoinableSitesText />}
                    />
                ) : (
                    <>
                        <WelcomeBackHeading />
                        <JoinableSitesSubheading />
                    </>
                )}
                <SiteActivation
                    CurrentProductJoinableUser={<JoinableSites />}
                    useContactExpandCohortLogic={true}
                />
            </div>
        </JiraOverlayTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "10px"
});
